<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="bg-content padding15">
          <el-form size="small" label-width="100px" ref="searchRef">
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="公司">
                  <el-select v-model="searchReq.companyId" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in companyNameList"
                      :key="item.id"
                      :label="item.companyName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="创建时间">
                  <el-date-picker v-model="searchReq.startTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="12">
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select v-model="searchReq.state" filterable clearable placeholder="请选择" style="width: 100%;">
                    <el-option
                      v-for="item in stateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 按钮操作 -->
              <div class="padding15-tb text right">
                <el-button type="primary" size="small" plain @click="searchReq.page = 1; getList();"><i class="fa fa-search"></i> 搜索</el-button>
                <el-button size="small" @click="reset">重置</el-button>
              </div>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-table size="small" :data="timinglist.list" v-loading="loading">
            <el-table-column fixed property="companyName" label="公司" align="center"/>
            <el-table-column fixed property="groupName"  label="策略组" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.groupName">{{ scope.row.groupName }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="timingTime"  label="发送时间" align="center"/>
            <el-table-column fixed property="timingType"  label="定时类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.groupType === 3">路由</span>
                <span v-else-if="scope.row.timingType.includes('msg') && scope.row.timingType.includes('interface')">接口短信</span>
                <span v-else-if="scope.row.timingType.includes('ivr') && scope.row.timingType.includes('interface')">接口语音</span>
                <span v-else-if="scope.row.timingType.includes('ivoice') && scope.row.timingType.includes('interface')">接口智能语音</span>
                <span v-else-if="scope.row.timingType.includes('svoice') && scope.row.timingType.includes('interface')">接口场景语音</span>
                <span v-else-if="scope.row.timingType.includes('msg') && scope.row.timingType.includes('manual')">手发短信</span>
                <span v-else-if="scope.row.timingType.includes('ivr') && scope.row.timingType.includes('manual')">手发语音</span>
                <span v-else-if="scope.row.timingType.includes('ivoice') && scope.row.timingType.includes('manual')">手发智能语音</span>
                <span v-else-if="scope.row.timingType.includes('svoice') && scope.row.timingType.includes('manual')">手发场景语音</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="templateName"  label="发送模板" align="center">
              <template slot-scope="scope">
                <el-tooltip placement="top" effect="light">
                  <div slot="content" v-html="scope.row.templateContent"></div>
                  <span>{{scope.row.templateName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column fixed property="state"  label="状态" align="center">
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.state === 0">未执行</el-tag>
                <el-tag v-else-if="scope.row.state === 1">已执行</el-tag>
                <el-tag type="info" v-else-if="scope.row.state === 2">取消执行</el-tag>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="caseCount" label="案件条数" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.caseCount">{{ scope.row.caseCount }}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="createTime"  label="添加时间"  align="center"/>
            <el-table-column fixed property="updateTime"  label="更新时间"  align="center"/>
            <el-table-column fixed label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.state !== 1" size="small" @click="updateButton(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" v-else size="small" disabled><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="text center margin15-tb">
            <el-pagination
              background
              layout="prev, pager, next, sizes, total"
              :total="timinglist.totalRecords"
              :page-size="searchReq.limit"
              :current-page="searchReq.page"
              @current-change="currentChange"
              @size-change="sizeChange">
            </el-pagination>
          </div>
        </div>
        <!-- 添加/编辑定时任务 -->
        <el-dialog title="编辑" :visible.sync="updateVisible" width="50%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="公司名称" v-if="this.$partB()">
                <el-select v-model="updateReq.companyId" filterable  placeholder="请选择" style="width: 80%;" disabled>
                  <el-option
                    v-for="item in companyNameList"
                    :key="item.id"
                    :label="item.companyName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发送时间">
                <el-date-picker style="width: 80%;"
                  v-model="updateReq.timingTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="updateReq.state" filterable placeholder="请选择" style="width: 80%;">
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="updateVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="update">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      searchReq: {
        companyId: null,
        state: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      timinglist: { 'totalRecords': 0, list: [] },
      companyNameList: [],
      stateList: [
        { value: 0, label: '未执行' },
        { value: 1, label: '已执行' },
        { value: 2, label: '取消执行' },
        { value: 3, label: '执行中' }
      ],
      updateReq: {
        id: null,
        companyId: null,
        timingTime: null,
        state: null
      },
      updateVisible: false
    };
  },
  mounted() {
    this.getTime();
    this.getList();
    this.companyList();
  },
  methods: {
    getList() {
      this.loading = true;
      this.$ajax({
        method: 'POST',
        url: '/timingRecord/list',
        data: this.searchReq
      }).then((res) => {
        this.timinglist.list = res.data.list;
        this.timinglist.totalRecords = res.data.totalRecords;
        this.loading = false;
      });
    },
    updateButton(row) {
      this.updateReq.id = row.id;
      this.updateReq.companyId = row.companyId;
      this.updateReq.timingTime = row.timingTime;
      this.updateReq.state = row.state;
      this.updateVisible = true;
    },
    update() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        method: 'POST',
        url: '/timingRecord/update',
        data: this.updateReq
      }).then(() => {
        loading.close();
        this.getList();
        this.updateVisible = false;
      }).catch(() => {
        loading.close();
      });
    },
    // 获取当天时间
    getTime() {
      const day = new Date();
      day.setTime(day.getTime());
      let month = null;
      if (day.getMonth() < 9) {
        month = day.getMonth() + 1;
        month = `0${month}`;
      } else {
        month = day.getMonth() + 1;
      }
      let date = null;
      if (day.getDate() < 10) {
        date = `0${day.getDate()}`;
      } else {
        date = day.getDate();
      }
      const s1 = `${day.getFullYear()}-${month}-${date} 00:00:00`;
      this.searchReq.startTime = s1;
    },
    // 重置
    reset() {
      this.getTime();
      this.searchReq.companyId = null;
      this.searchReq.state = null;
      this.searchReq.endTime = null;
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.getList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.getList();
    },
    // 获取公司列表
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyNameList = res.data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/job/list.vue